(function(){
	'use strict';

	angular
	.module('app.blog')
	.controller('InternaBlogController', InternaBlogController)

	function InternaBlogController(API, $stateParams, $state, config, $filter, blogFactory) {
		let vm = this;

		let urlId = $stateParams.sluginterna;

		vm.$onInit = () => {
			getFromAPI();
		}

		function getFromAPI() {
			API.get('post/' + urlId).then(result => {
				vm.post = result.data[0];
			});
			API.get('projeto/destaques').then(result => {
				vm.solucoes = result.data;
			});
		}

		vm.slideStyle = function (image) {
			const style = {}
			const imageUrl = $filter('uploadImageUrl')(image.nome_imagem)
			style['background-image'] = 'url(' + imageUrl + ')'
			return style
		}

		vm.goToCategory = function (category) {
			blogFactory.setCategory(category)
			$state.go('blog')
		}

		vm.flex_cases = function(){
			$('#slider').flexslider({
				animation: "slide",
				controlNav: false,
				animationLoop: false,
				slideshow: true
			});
		}

		vm.twitter = function (s, a, b){
			const url = config.baseUrl + 'blog/' + vm.post.slug_post
			window.open('https://twitter.com/share?text=' + vm.post.titulo_post + ' - Veja em: ' + url + '/&url=URL', 'Pagina', 'STATUS=NO, TOOLBAR=NO, LOCATION=NO, DIRECTORIES=NO, RESISABLE=NO, SCROLLBARS=YES, TOP=10, LEFT=10, WIDTH=770, HEIGHT=400');
		};
		vm.linkedin = function () {
			const url = config.baseUrl + 'blog/' + vm.post.slug_post
			window.open('https://www.linkedin.com/shareArticle?url=' + url +'',  'Pagina', 'STATUS=NO, TOOLBAR=NO, LOCATION=NO, DIRECTORIES=NO, RESISABLE=NO, SCROLLBARS=YES, TOP=10, LEFT=10, WIDTH=770, HEIGHT=200');
		};
		
		vm.facebook = function () {
			const url = config.baseUrl + 'blog/' + vm.post.slug_post
			window.open('https://www.facebook.com/sharer/sharer.php?u=' + url, '/&display=popup&ref=plugin', 'Pagina', 'STATUS=NO, TOOLBAR=NO, LOCATION=NO, DIRECTORIES=NO, RESISABLE=NO, SCROLLBARS=YES, TOP=10, LEFT=10, WIDTH=770, HEIGHT=200');
		};
	}

})();
